var _path, _path2, _path3, _path4, _path5, _path6, _mask, _g, _path7, _path8, _path9, _mask2, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlaidBoatHat = function SvgPlaidBoatHat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 44,
    viewBox: "0 0 65 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3282 28.986L0 20.6685L21.9491 19.9754L17.3282 28.986Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3282 28.986L0 20.6685L21.9491 19.9754L17.3282 28.986Z",
    fill: "url(#boat_hat_paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6741 28.755L42.2808 19.7444L64.6919 18.8202L49.6741 28.755Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6741 28.755L42.2808 19.7444L64.6919 18.8202L49.6741 28.755Z",
    fill: "url(#boat_hat_paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4162 0.860352L9.08731 27.9506L32.4162 35.9235V0.860352Z",
    fill: "url(#boat_hat_paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71951 28.3469L32.0484 1.25669V36.3199L8.71951 28.3469ZM32.3375 1.34016L32.2479 36.6912L36.1988 39.0544L52.3715 29.9526L32.3375 1.34016Z",
    fill: "#A51C35"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "boat_hat_mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 1,
    width: 45,
    height: 39
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71951 28.3469L32.0484 1.25669V36.3199L8.71951 28.3469ZM32.3375 1.34016L32.2479 36.6912L36.1988 39.0544L52.3715 29.9526L32.3375 1.34016Z",
    fill: "#A51C35"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#boat_hat_mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.1951,
    y: 0.860359,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.3597,
    y: 7.59816,
    width: 4.7561,
    height: 66.5853,
    transform: "rotate(90 69.3597 7.59816)",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.3597,
    y: 14.7323,
    width: 4.7561,
    height: 66.5853,
    transform: "rotate(90 69.3597 14.7323)",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.061,
    y: 0.860359,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.0305,
    y: -0.328663,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.8963,
    y: -0.328663,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62973 39.7716L0.308044 21.0379L30.571 25.3722L65 19.1896L58.1494 38.0632L31.7913 43.4324L7.62973 39.7716Z",
    fill: "url(#boat_hat_paint3_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62973 39.7716L0.308044 21.0379L30.571 25.3722L65 19.1896L58.1494 38.0632L31.7913 43.4324L7.62973 39.7716Z",
    fill: "url(#boat_hat_paint4_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32169 39.4633L0 20.7296L30.263 25.0639L64.692 18.8813L57.8413 37.7549L31.4833 43.1241L7.32169 39.4633Z",
    fill: "#A51C35"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "boat_hat_mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 19,
    width: 65,
    height: 25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32169 39.674L0 20.9404L30.263 25.2747L64.692 19.092L57.8413 37.9657L31.4833 43.3349L7.32169 39.674Z",
    fill: "#A51C35"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#boat_hat_mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5427,
    y: 13.9396,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8171,
    y: 13.9396,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9817,
    y: 20.6774,
    width: 4.7561,
    height: 66.5853,
    transform: "rotate(90 66.9817 20.6774)",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9817,
    y: 27.8116,
    width: 4.7561,
    height: 66.5853,
    transform: "rotate(90 66.9817 27.8116)",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.4085,
    y: 13.9396,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6829,
    y: 13.9396,
    width: 4.7561,
    height: 30.1219,
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint0_linear",
    x1: 10.9745,
    y1: 19.9754,
    x2: 10.9745,
    y2: 28.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint1_linear",
    x1: 53.4863,
    y1: 18.8202,
    x2: 53.4863,
    y2: 28.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint2_linear",
    x1: 27.4932,
    y1: -9.30524,
    x2: 27.9553,
    y2: 64.7033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557327,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint3_linear",
    x1: 32.6531,
    y1: 4.92637,
    x2: 32.6531,
    y2: 37.1174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC8387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint4_linear",
    x1: 32.6531,
    y1: 10.9333,
    x2: 32.6531,
    y2: 54.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaidBoatHat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plaid_boat_hat.2214b240.svg";
export { ForwardRef as ReactComponent };